module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Light.645112b1.ttf";